var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"header"}},[_c('div',{staticClass:"left",on:{"click":_vm.back}},[_vm._t("left",[_c('font',[_c('span',[_vm._v("")])])])],2),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"right bf"},[_vm._t("right")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-69f6e730","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/base/app-header.vue
// module id = 1042
// module chunks = 358